import type { ChartData, DailyCheckIn } from "./types";

export const getImpactText = (value: number): string => {
	switch (value) {
		case 0:
			return "No Impact";
		case 3:
			return "Break-through Positive";
		case 2:
			return "Highly Positive";
		case 1:
			return "Slightly Positive";
		case -1:
			return "Slightly Negative";
		case -2:
			return "Highly Negative";
		case -3:
			return "Critically Negative";
		default:
			return "Unknown";
	}
};

export const calculateChartData = (checkIns: DailyCheckIn[]): ChartData[] => {
	const chartPoints: ChartData[] = [];
	let cumulativeScore = 0;

	checkIns.forEach((checkIn) => {
		cumulativeScore += checkIn.general_feeling;
		chartPoints.push({
			date: new Date(checkIn.created_at).toLocaleDateString("en-US", {
				month: "short",
				day: "numeric",
			}),
			feeling: cumulativeScore,
			label: new Date(checkIn.created_at).toLocaleDateString(),
			checkInId: checkIn.id,
			description: checkIn.day_description || "",
			generalFeeling: checkIn.general_feeling,
			reflectionId: checkIn.reflection_id,
			reflectionTitle: checkIn.reflection?.title || null,
		});
	});

	return chartPoints.map((point, index) => {
		const windowSize = Math.min(7, index + 1);
		const windowStart = Math.max(0, index - windowSize + 1);
		const windowData = chartPoints.slice(windowStart, index + 1);
		const average =
			windowData.reduce((sum, p) => sum + p.feeling, 0) / windowData.length;

		return {
			...point,
			rollingAverage: average,
		};
	});
};

export const calculateTotalPages = (
	totalCount: number,
	pageSize: number,
): number => {
	return Math.max(1, Math.ceil(totalCount / pageSize));
};

export const getFirstThreeSentences = (text: string): string => {
	if (!text) return "";

	const sentences = text.match(/[^.!?]+[.!?]+/g) || [];
	if (sentences.length > 0) {
		return sentences.slice(0, 3).join(" ").trim();
	}

	const fallback = text
		.split(/[.!?]+/)
		.filter((s) => s.trim().length > 0)
		.slice(0, 3);
	if (fallback.length > 0) {
		return fallback.join(". ").trim();
	}

	return text.length > 160 ? text.substring(0, 160) + "..." : text;
};
